var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSisi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.1,
    height: 68.101,
    viewBox: "0 0 68.1 68.101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1446",
    "data-name": "Grupo 1446",
    transform: "translate(568.381 -8187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1439",
    "data-name": "Grupo 1439",
    transform: "translate(-1538.976 2860.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_975",
    "data-name": "Grupo 975",
    transform: "translate(970.595 5326.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1732",
    "data-name": "Rect\\xE1ngulo 1732",
    fill: "none",
    stroke: "#1de9b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.1,
    height: 68.1,
    rx: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 67.1,
    height: 67.1,
    rx: 13.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1440",
    "data-name": "Grupo 1440",
    transform: "translate(-115.007 -169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1606",
    "data-name": "Trazado 1606",
    d: "M222.926,24.1a8.3,8.3,0,1,1,8.3-8.3,8.311,8.311,0,0,1-8.3,8.3m0-11.165a2.862,2.862,0,1,0,2.862,2.862,2.865,2.865,0,0,0-2.862-2.862",
    transform: "translate(-655 8383.898)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1607",
    "data-name": "Trazado 1607",
    d: "M240.235,8.882c-.044,0-.087,0-.131,0l-15.477-.726a2.721,2.721,0,0,1,.253-5.435l15.479.726a2.721,2.721,0,0,1-.125,5.438",
    transform: "translate(-642.253 8375.666)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1608",
    "data-name": "Trazado 1608",
    d: "M227.469,20.921c-.044,0-.087,0-.131,0a2.722,2.722,0,0,1-2.59-2.846L225.475,2.6a2.721,2.721,0,0,1,5.435.253l-.726,15.479a2.72,2.72,0,0,1-2.715,2.593",
    transform: "translate(-637.589 8371)",
    fill: "#02ceff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1609",
    "data-name": "Trazado 1609",
    d: "M223.4,13.413a2.72,2.72,0,0,1-1.79-4.769l2.639-2.307a2.721,2.721,0,1,1,3.583,4.1l-2.642,2.307a2.713,2.713,0,0,1-1.79.672",
    transform: "translate(-644.584 8380.743)",
    fill: "#02ceff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSisi);
export default __webpack_public_path__ + "static/media/ic_sisi.4eeef3481cc8d61ceb55e26c491a8c11.svg";
export { ForwardRef as ReactComponent };